'use client';

import { FC, ReactElement } from 'react';

import { useBottomContainerContext } from '@ravago/shared/page-elements-radiance/context/bottom-container-context';
import { NotificationProvider } from '@ravago/shared/radiance/providers/notifications/NotificationProvider';

interface Props {
  widget: ReactElement;
}

const BottomContainer: FC<Props> = ({ widget }) => {
  const { hasBottomSheet } = useBottomContainerContext();

  return (
    <>
      <NotificationProvider
        containerStyle={{
          zIndex: 0,
          bottom: hasBottomSheet ? 180 : 80
        }}
      />

      <div style={{ position: 'fixed', bottom: hasBottomSheet ? 92 : 0, left: 0, right: 0 }}>{widget}</div>
    </>
  );
};

export default BottomContainer;
